
(function () {
window.onpageshow = function (evt) {
    if (evt.persisted) window.location.reload();
};
})();



// ---- helpers available to both paths ----
function getSealTarget() {
return document.querySelector('.sealsubs-target-element.sealsubs-full[data-product]');
}

function parseProductJSON(el) {
if (!el) return null;
try {
    const raw = el.dataset.product || '';
    return JSON.parse(raw.replaceAll('&quot;', '"'));
} catch (e) {
    console.warn('[jolly] Failed to parse product JSON', e);
    return null;
}
}

// ---- define (or reuse) the custom element ----
class JollySubscriptionOnetime extends HTMLElement {
constructor() {
    super();
    this._bound = false; // ensure we only wire once
}

connectedCallback() {
    if (this._bound) return;
    this._bound = true;

    this.elements = {
    subscriptionPurchase: document.querySelector('#subscription_purchase'),
    onetimePurchase: document.querySelector('#onetime_purchase'),
    subscriptionBlock: document.querySelector('#subscription_block'),
    onetimeBlock: document.querySelector('#onetime_block'),
    weightButtons: document.querySelectorAll('.jolly-btn-weight'),
    dataProductObj: '',
    jollyPlanInputs: document.querySelectorAll('.jolly-plan-input'),
    quantityInput: document.querySelector('input[name="quantity"]'),
    buyButtonText: document.querySelector('.jolly-buy-btn-text'),
    saveMessageMoneySpan: document.querySelector('.jolly-save-message-money'),
    buyForm: document.querySelector('.jolly-buy-form'),
    loadingIcon: document.querySelector('.jolly-loading-icon'),
    };

    // One-time init path if widget is already on the page
    const existingTarget = getSealTarget();
    if (existingTarget) {
    console.log('[jolly] widget found immediately');
    this.elements.dataProductObj = existingTarget;
    this._wireUI();
    this.init(parseProductJSON(existingTarget));
    this._postInit();
    }

    // Event path (fires when Seal app creates the widget)
    document.addEventListener(
    'sealsubs:subscription_widget_created',
    () => {
        console.log('[jolly] hiiiiii (event)'); // <-- your console log
        this.elements.dataProductObj = getSealTarget();
        this._wireUI();
        this.init(parseProductJSON(this.elements.dataProductObj));
        this._postInit();
    },
    { once: true } // avoid duplicate init
    );
}

// --- split wiring to avoid repeating ---
_wireUI() {
    const els = this.elements;

    // safety guards
    if (!els.subscriptionPurchase || !els.onetimePurchase) return;

    els.onetimePurchase.addEventListener('click', () => {
    this.switchBlock(els.subscriptionBlock, els.onetimeBlock);
    this.init();
    });

    els.jollyPlanInputs.forEach((input) => {
    input.addEventListener('click', () => {
        this.planInputsClick(input, parseProductJSON(els.dataProductObj));
        this.setQuantity(input);
        this.setButtonText(input);
        this.setSaveMoneyMessageMoney(input);
    });
    });

    els.subscriptionPurchase.addEventListener('click', () => {
    this.switchBlock(els.onetimeBlock, els.subscriptionBlock);
    this.init(parseProductJSON(els.dataProductObj));
    });

    els.weightButtons.forEach((btn) => {
    btn.addEventListener('click', () => {
        this.switchBlockWeight(btn, parseProductJSON(els.dataProductObj));
    });
    });

    this.onloadReset();
}

_postInit() {
    if (this.elements.loadingIcon) this.elements.loadingIcon.style.display = 'none';
    if (this.elements.buyForm) this.elements.buyForm.classList.add('jolly-loaded');
    this.classList.add('jolly-loaded');
}

onloadReset() {
    const subBlock = this.elements.subscriptionBlock;
    if (!subBlock || !this.elements.subscriptionPurchase) return;

    // Clicks only if elements exist
    this.elements.subscriptionPurchase.click();
    subBlock.querySelector('.jolly-btn-weight')?.click();
    subBlock.querySelector('.jolly-plan-input')?.click();
}

init(productObj) {
    const els = this.elements;
    if (!els) return;

    if (els.subscriptionPurchase?.checked) {
    let idx, activeWeightEl;
    document.querySelectorAll('.jolly-weight-input-subscription').forEach((el) => {
        if (el.checked) {
        idx = el.dataset.jollyIndex;
        activeWeightEl = el;
        }
    });
    if (!activeWeightEl) return;

    const plansWrap = activeWeightEl.closest('.jolly-block')
        ?.querySelector(`[data-plan-index^="${idx}"]`);
    if (!plansWrap) return;

    const currentPlan = this.getCurrentPlanIndex(plansWrap);
    if (!currentPlan) return;

    this.setQuantity(currentPlan);
    this.setButtonText(currentPlan);

    const appPlanIdx = this.findAppPlan(currentPlan.dataset.planName, productObj || {});
    document.querySelector(`[data-selling-plan-group^="${appPlanIdx}"]`)?.click();

    } else if (els.onetimePurchase?.checked) {
    let idx, activeWeightEl;
    document.querySelectorAll('.jolly-weight-input-onetime').forEach((el) => {
        if (el.checked) {
        idx = el.dataset.jollyIndex;
        activeWeightEl = el;
        }
    });
    if (!activeWeightEl) return;

    const plansWrap = activeWeightEl.closest('.jolly-block')
        ?.querySelector(`[data-plan-index^="${idx}"]`);
    if (!plansWrap) return;

    const currentPlan = this.getCurrentPlanIndex(plansWrap);
    if (!currentPlan) return;

    this.setQuantity(currentPlan);
    this.setButtonText(currentPlan);
    this.setSaveMoneyMessageMoney(currentPlan);

    document.querySelector('[data-type="one_time"]')?.click();
    }
}

switchBlock(hideEl, showEl) {
    hideEl?.classList.add('jc-hidden');
    showEl?.classList.remove('jc-hidden');
}

planInputsClick(inputEl, productObj) {
    if (inputEl.closest('.jolly-block')?.id !== 'subscription_block') return;
    const planName = inputEl.dataset.planName;
    const appPlanIdx = this.findAppPlan(planName, productObj || {});
    document.querySelector(`[data-selling-plan-group^="${appPlanIdx}"]`)?.click();
}

setQuantity(planInputEl) {
    const qty = planInputEl?.dataset?.jollyQuantity;
    if (qty && this.elements.quantityInput) this.elements.quantityInput.value = qty;
}

setButtonText(planInputEl) {
    const txt = planInputEl?.dataset?.jollyButtonText;
    if (txt && this.elements.buyButtonText) this.elements.buyButtonText.innerHTML = txt;
}

setSaveMoneyMessageMoney(planInputEl) {
    const msg = planInputEl?.dataset?.jollySaveMessageMoney;
    if (msg && this.elements.saveMessageMoneySpan) {
    this.elements.saveMessageMoneySpan.innerHTML = msg;
    }
}

switchBlockWeight(weightBtn, productObj) {
    const block = weightBtn.closest('.jolly-block');
    const idx = weightBtn.dataset.jollyIndex;
    if (!block || !idx) return;

    const allPlanGroups = block.querySelectorAll('[data-plan-index]');
    const targetPlansWrap = block.querySelector(`[data-plan-index^="${idx}"]`);
    if (!targetPlansWrap) return;

    const currentPlan = this.getCurrentPlanIndex(targetPlansWrap);
    if (!currentPlan) return;

    this.setQuantity(currentPlan);
    this.setButtonText(currentPlan);
    this.setSaveMoneyMessageMoney(currentPlan);

    allPlanGroups.forEach((grp) => grp.classList.add('jc-hidden'));
    targetPlansWrap.classList.remove('jc-hidden');

    if (block.id === 'subscription_block') {
    const appPlanIdx = this.findAppPlan(
        this.getCurrentPlanIndex(targetPlansWrap)?.dataset.planName,
        productObj || {}
    );
    document.querySelector(`[data-selling-plan-group^="${appPlanIdx}"]`)?.click();
    }
}

getCurrentPlanIndex(plansWrap) {
    let active = null;
    plansWrap?.querySelectorAll('.jolly-plan-input')?.forEach((el) => {
    if (el.checked) active = el;
    });
    return active;
}

findAppPlan(planName, productObj) {
    const groups = productObj?.selling_plan_groups || [];
    let foundIndex;
    groups.forEach((grp, i) => {
    if (planName === grp.name.replace(/ +/g, '-').toLowerCase()) {
        foundIndex = i;
    }
    });
    return foundIndex;
}
}

// Define once, but ALWAYS create/upgrade instances already in DOM.
if (!customElements.get('jolly-subscription-onetime')) {
customElements.define('jolly-subscription-onetime', JollySubscriptionOnetime);
}

window.addEventListener('DOMContentLoaded', function () {
// Ensure an instance exists so connectedCallback runs.
if (!document.querySelector('jolly-subscription-onetime')) {
    document.body.appendChild(document.createElement('jolly-subscription-onetime'));
}
});

